<template>
	<header
		:class="[
			'header',
			{
				header_mobile: isHeaderMobile || isScrolable,
				header_scrolled: isScrolled,
				header_transparent: isDarkHeaderRoute,
			},
		]"
	>
		<div class="header__inner _cnt">
			<router-link
				v-if="!isDarkHeaderRoute || isScrolled"
				to="/"
				class="header__logo"
			>
				<svg
					width="187"
					height="40"
					viewBox="0 0 187 40"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_51_1427)">
						<mask id="path-1-inside-1_51_1427" fill="white">
							<path
								d="M14.4739 0.727686C17.2795 -0.293423 20.3442 0.859705 21.8289 3.32458C21.8518 3.36251 21.9005 3.37616 21.9398 3.35573C22.0983 3.2733 22.2642 3.20066 22.4366 3.1379C24.561 2.36469 26.9104 3.46025 27.6836 5.58462C28.4567 7.70893 27.3609 10.0575 25.2366 10.8307C23.9269 11.3074 22.5324 11.0738 21.4739 10.3268C21.4377 10.3013 21.3877 10.3082 21.36 10.3427C20.6807 11.1901 19.7691 11.8688 18.674 12.2674C16.9497 12.895 15.1271 12.7015 13.6334 11.8872C13.5769 11.8564 13.507 11.8985 13.5064 11.9629C13.4955 13.2904 12.6731 14.5326 11.3522 15.0133C11.1143 15.0999 10.8727 15.1563 10.6316 15.1859C10.5814 15.192 10.5474 15.2409 10.5585 15.2903C10.8237 16.4766 10.1752 17.704 9.00243 18.131C7.72792 18.5949 6.31853 17.9375 5.85447 16.6631C5.39055 15.3885 6.04777 13.979 7.32239 13.5151C7.3397 13.5088 7.34775 13.4893 7.33915 13.473C7.26912 13.3405 7.20812 13.2011 7.15539 13.0563C6.53683 11.3568 7.41265 9.47712 9.11208 8.85851C9.64591 8.66422 10.1976 8.61793 10.7223 8.69788C10.7786 8.70645 10.8232 8.65167 10.8038 8.5982C9.64397 5.41165 11.2873 1.8875 14.4739 0.727686Z"
							/>
						</mask>
						<path
							d="M14.4739 0.727686C17.2795 -0.293423 20.3442 0.859705 21.8289 3.32458C21.8518 3.36251 21.9005 3.37616 21.9398 3.35573C22.0983 3.2733 22.2642 3.20066 22.4366 3.1379C24.561 2.36469 26.9104 3.46025 27.6836 5.58462C28.4567 7.70893 27.3609 10.0575 25.2366 10.8307C23.9269 11.3074 22.5324 11.0738 21.4739 10.3268C21.4377 10.3013 21.3877 10.3082 21.36 10.3427C20.6807 11.1901 19.7691 11.8688 18.674 12.2674C16.9497 12.895 15.1271 12.7015 13.6334 11.8872C13.5769 11.8564 13.507 11.8985 13.5064 11.9629C13.4955 13.2904 12.6731 14.5326 11.3522 15.0133C11.1143 15.0999 10.8727 15.1563 10.6316 15.1859C10.5814 15.192 10.5474 15.2409 10.5585 15.2903C10.8237 16.4766 10.1752 17.704 9.00243 18.131C7.72792 18.5949 6.31853 17.9375 5.85447 16.6631C5.39055 15.3885 6.04777 13.979 7.32239 13.5151C7.3397 13.5088 7.34775 13.4893 7.33915 13.473C7.26912 13.3405 7.20812 13.2011 7.15539 13.0563C6.53683 11.3568 7.41265 9.47712 9.11208 8.85851C9.64591 8.66422 10.1976 8.61793 10.7223 8.69788C10.7786 8.70645 10.8232 8.65167 10.8038 8.5982C9.64397 5.41165 11.2873 1.8875 14.4739 0.727686Z"
							fill="white"
						/>
						<path
							d="M14.4739 0.727686L14.3029 0.257837L14.3029 0.257839L14.4739 0.727686ZM22.4366 3.1379L22.2656 2.66805L22.4366 3.1379ZM27.6836 5.58462L28.1535 5.41364L28.1535 5.41361L27.6836 5.58462ZM25.2366 10.8307L25.4076 11.3006L25.2366 10.8307ZM18.674 12.2674L18.845 12.7372L18.845 12.7372L18.674 12.2674ZM11.3522 15.0133L11.5232 15.4832L11.5233 15.4832L11.3522 15.0133ZM9.00243 18.131L9.17344 18.6008L9.17347 18.6008L9.00243 18.131ZM5.85447 16.6631L5.38462 16.8341L5.38465 16.8342L5.85447 16.6631ZM7.32239 13.5151L7.15141 13.0453L7.15138 13.0453L7.32239 13.5151ZM7.15539 13.0563L6.68554 13.2273L6.68555 13.2273L7.15539 13.0563ZM9.11208 8.85851L8.94107 8.38867L8.94105 8.38867L9.11208 8.85851ZM10.8038 8.5982L10.3339 8.76921L10.3339 8.76923L10.8038 8.5982ZM7.33915 13.473L6.89706 13.7066L7.33915 13.473ZM10.6316 15.1859L10.5707 14.6896L10.6316 15.1859ZM10.5585 15.2903L11.0464 15.1812L10.5585 15.2903ZM13.6334 11.8872L13.3941 12.3263L13.6334 11.8872ZM13.5064 11.9629L13.0065 11.9588L13.5064 11.9629ZM10.7223 8.69788L10.647 9.19217L10.7223 8.69788ZM21.36 10.3427L20.9699 10.03L21.36 10.3427ZM21.8289 3.32458L22.2572 3.0666L21.8289 3.32458ZM21.9398 3.35573L21.7091 2.91213L21.9398 3.35573ZM14.4739 0.727686L14.6449 1.19753C17.2212 0.259881 20.0368 1.31835 21.4006 3.58257L21.8289 3.32458L22.2572 3.0666C20.6517 0.401062 17.3378 -0.846728 14.3029 0.257837L14.4739 0.727686ZM21.9398 3.35573L22.1705 3.79932C22.3089 3.72732 22.4548 3.66336 22.6076 3.60774L22.4366 3.1379L22.2656 2.66805C22.0736 2.73796 21.8876 2.81927 21.7091 2.91213L21.9398 3.35573ZM22.4366 3.1379L22.6076 3.60774C24.4725 2.92898 26.535 3.89075 27.2138 5.75563L27.6836 5.58462L28.1535 5.41361C27.2858 3.02975 24.6495 1.8004 22.2656 2.66805L22.4366 3.1379ZM27.6836 5.58462L27.2138 5.7556C27.8924 7.62032 26.9305 9.68209 25.0656 10.3609L25.2366 10.8307L25.4076 11.3006C27.7912 10.433 29.021 7.79754 28.1535 5.41364L27.6836 5.58462ZM25.2366 10.8307L25.0656 10.3609C23.9164 10.7791 22.6926 10.5749 21.7621 9.91831L21.4739 10.3268L21.1856 10.7354C22.3721 11.5726 23.9375 11.8356 25.4076 11.3006L25.2366 10.8307ZM21.36 10.3427L20.9699 10.03C20.3459 10.8083 19.5092 11.4312 18.5029 11.7975L18.674 12.2674L18.845 12.7372C20.029 12.3063 21.0154 11.5719 21.7501 10.6555L21.36 10.3427ZM18.674 12.2674L18.503 11.7975C16.9192 12.3739 15.2458 12.1967 13.8727 11.4482L13.6334 11.8872L13.3941 12.3263C15.0083 13.2062 16.9801 13.416 18.845 12.7372L18.674 12.2674ZM13.5064 11.9629L13.0065 11.9588C12.9972 13.0847 12.2994 14.1365 11.1812 14.5435L11.3522 15.0133L11.5233 15.4832C13.0468 14.9286 13.9938 13.4961 14.0064 11.967L13.5064 11.9629ZM11.3522 15.0133L11.1812 14.5435C10.9801 14.6167 10.7756 14.6644 10.5707 14.6896L10.6316 15.1859L10.6926 15.6821C10.9698 15.6481 11.2484 15.5832 11.5232 15.4832L11.3522 15.0133ZM10.5585 15.2903L10.0705 15.3994C10.2818 16.3442 9.76459 17.3214 8.83138 17.6612L9.00243 18.131L9.17347 18.6008C10.5859 18.0866 11.3657 16.609 11.0464 15.1812L10.5585 15.2903ZM9.00243 18.131L8.83142 17.6612C7.81647 18.0306 6.69391 17.507 6.32429 16.492L5.85447 16.6631L5.38465 16.8342C5.94315 18.3679 7.63938 19.1592 9.17344 18.6008L9.00243 18.131ZM5.85447 16.6631L6.32432 16.4921C5.95484 15.4769 6.47826 14.3544 7.4934 13.985L7.32239 13.5151L7.15138 13.0453C5.61727 13.6036 4.82625 15.3 5.38462 16.8341L5.85447 16.6631ZM7.33915 13.473L7.78123 13.2394C7.72277 13.1288 7.67083 13.0105 7.62522 12.8852L7.15539 13.0563L6.68555 13.2273C6.7454 13.3917 6.81546 13.5522 6.89706 13.7066L7.33915 13.473ZM7.15539 13.0563L7.62523 12.8853C7.10106 11.4451 7.84332 9.85245 9.2831 9.32835L9.11208 8.85851L8.94105 8.38867C6.98198 9.10179 5.9726 11.2685 6.68554 13.2273L7.15539 13.0563ZM9.11208 8.85851L9.28309 9.32836C9.7359 9.16355 10.2028 9.12449 10.647 9.19217L10.7223 8.69788L10.7976 8.20358C10.1925 8.11138 9.55591 8.16488 8.94107 8.38867L9.11208 8.85851ZM10.8038 8.5982L11.2736 8.42719C10.2083 5.50013 11.7178 2.2629 14.6449 1.19753L14.4739 0.727686L14.3029 0.257839C10.8568 1.5121 9.07968 5.32317 10.3339 8.76921L10.8038 8.5982ZM7.32239 13.5151L7.49336 13.985C7.7814 13.8802 7.93855 13.5372 7.78123 13.2394L7.33915 13.473L6.89706 13.7066C6.75696 13.4414 6.89801 13.1375 7.15141 13.0453L7.32239 13.5151ZM10.6316 15.1859L10.5707 14.6896C10.2231 14.7323 9.9959 15.0658 10.0705 15.3994L10.5585 15.2903L11.0464 15.1812C11.0989 15.416 10.9397 15.6518 10.6926 15.6821L10.6316 15.1859ZM13.6334 11.8872L13.8727 11.4482C13.4765 11.2323 13.01 11.526 13.0065 11.9588L13.5064 11.9629L14.0064 11.967C14.0039 12.271 13.6772 12.4806 13.3941 12.3263L13.6334 11.8872ZM10.7223 8.69788L10.647 9.19217C11.0808 9.25827 11.4222 8.83547 11.2736 8.42718L10.8038 8.5982L10.3339 8.76923C10.2242 8.46787 10.4764 8.15463 10.7976 8.20358L10.7223 8.69788ZM21.4739 10.3268L21.7621 9.91831C21.5119 9.74171 21.1643 9.78748 20.9699 10.03L21.36 10.3427L21.7501 10.6555C21.6111 10.8288 21.3635 10.8609 21.1856 10.7354L21.4739 10.3268ZM21.8289 3.32458L21.4006 3.58257C21.5601 3.84733 21.8977 3.9412 22.1705 3.79932L21.9398 3.35573L21.7091 2.91213C21.9033 2.81112 22.1434 2.8777 22.2572 3.0666L21.8289 3.32458Z"
							fill="#9F2C2C"
							mask="url(#path-1-inside-1_51_1427)"
						/>
						<path
							d="M17.4683 18.5951L16.1789 17.6476C16.1659 17.6381 16.156 17.6249 16.1504 17.6097L16.1089 17.4955C16.0934 17.453 16.1153 17.406 16.1578 17.3906L18.382 16.581C18.4244 16.5656 18.4464 16.5186 18.4309 16.4761L18.2457 15.9672C18.2302 15.9247 18.1832 15.9028 18.1407 15.9183L14.8705 17.1086C14.8543 17.1145 14.8404 17.1253 14.8309 17.1397C14.7799 17.2176 14.6094 17.4863 14.5462 17.6902C14.4375 18.0407 14.4071 18.278 14.5128 18.6294C14.5315 18.6915 14.5696 18.7854 14.5696 18.7854C14.7081 19.2751 13.5835 18.0557 13.5018 17.9667C13.4984 17.963 13.4959 17.9596 13.4933 17.9553C13.4565 17.8947 13.1714 17.4136 13.1708 17.065C13.1706 16.9382 13.1836 16.8669 13.2079 16.7424C13.2629 16.4619 13.4696 16.0844 13.5264 15.9843C13.5358 15.9677 13.5507 15.9555 13.5685 15.949L20.3021 13.4981C20.3165 13.4929 20.3319 13.4918 20.3467 13.4952C20.4931 13.529 21.3086 13.733 21.602 14.1508C21.7837 14.4093 21.8275 14.5992 21.8787 14.911C21.9191 15.1562 21.93 15.302 21.8896 15.5472C21.8175 15.9847 21.3638 16.5032 21.2336 16.6445C21.2123 16.6676 21.2056 16.7004 21.2163 16.7299L21.9369 18.7098C21.9524 18.7523 21.9305 18.7993 21.888 18.8147L18.2923 20.1235C18.2527 20.1379 18.2086 20.1199 18.1904 20.0819L17.4936 18.6258C17.4878 18.6136 17.4791 18.6031 17.4683 18.5951Z"
							fill="white"
							stroke="#9F2C2C"
							stroke-width="0.5"
						/>
						<path
							d="M27.4562 22.6375L16.5275 26.6152C16.474 26.6347 16.4174 26.595 16.4176 26.538L16.424 24.2281C16.4241 24.1989 16.4389 24.1724 16.4639 24.1574C16.6736 24.0307 17.6562 23.414 18.0094 22.7708C18.2524 22.3282 18.36 21.5767 18.3852 21.3767C18.3891 21.3457 18.4098 21.3198 18.4391 21.3091L22.63 19.7837C22.6419 19.7794 22.6545 19.7779 22.667 19.7794C22.8568 19.8022 24.4255 20.002 25.3121 20.4739C26.2321 20.9636 27.2288 22.1782 27.4931 22.5129C27.5272 22.5562 27.508 22.6186 27.4562 22.6375Z"
							fill="white"
							stroke="#9F2C2C"
							stroke-width="0.5"
						/>
						<path
							d="M30.5417 37.4465L23.8686 39.8753C23.8416 39.8852 23.8115 39.8801 23.7891 39.8621L20.761 37.4125C20.7115 37.3725 20.7247 37.2937 20.7845 37.2719L31.2309 33.4698C31.2907 33.448 31.3514 33.4999 31.3392 33.5624L30.5941 37.3853C30.5886 37.4134 30.5687 37.4367 30.5417 37.4465Z"
							fill="white"
							stroke="#9F2C2C"
							stroke-width="0.5"
						/>
						<path
							d="M31.2316 32.088L19.7658 36.2612C19.7295 36.2744 19.6884 36.2598 19.668 36.227C17.7491 33.1516 17.099 31.3281 16.6754 28.0068C16.6706 27.9689 16.6926 27.932 16.7285 27.919L28.1969 23.7448C28.2318 23.7321 28.2714 23.7451 28.2925 23.7757C30.2105 26.5512 30.8477 28.3875 31.2848 32.0005C31.2893 32.0383 31.2674 32.075 31.2316 32.088Z"
							fill="white"
							stroke="#9F2C2C"
							stroke-width="0.5"
						/>
						<circle
							cx="20.2989"
							cy="15.5256"
							r="0.736807"
							transform="rotate(-20 20.2989 15.5256)"
							fill="#9F2C2C"
						/>
					</g>
					<path
						d="M50.5341 17C50.4886 16.4318 50.2756 15.9886 49.8949 15.6705C49.5199 15.3523 48.9489 15.1932 48.1818 15.1932C47.6932 15.1932 47.2926 15.2528 46.9801 15.3722C46.6733 15.4858 46.446 15.642 46.2983 15.8409C46.1506 16.0398 46.0739 16.267 46.0682 16.5227C46.0568 16.733 46.0938 16.9233 46.179 17.0938C46.2699 17.2585 46.4119 17.4091 46.6051 17.5455C46.7983 17.6761 47.0455 17.7955 47.3466 17.9034C47.6477 18.0114 48.0057 18.108 48.4205 18.1932L49.8523 18.5C50.8182 18.7045 51.6449 18.9744 52.3324 19.3097C53.0199 19.6449 53.5824 20.0398 54.0199 20.4943C54.4574 20.9432 54.7784 21.4489 54.983 22.0114C55.1932 22.5739 55.3011 23.1875 55.3068 23.8523C55.3011 25 55.0142 25.9716 54.446 26.767C53.8778 27.5625 53.0653 28.1676 52.0085 28.5824C50.9574 28.9972 49.6932 29.2045 48.2159 29.2045C46.6989 29.2045 45.375 28.9801 44.2443 28.5312C43.1193 28.0824 42.2443 27.392 41.6193 26.4602C41 25.5227 40.6875 24.3239 40.6818 22.8636H45.1818C45.2102 23.3977 45.3438 23.8466 45.5824 24.2102C45.821 24.5739 46.1563 24.8494 46.5881 25.0369C47.0256 25.2244 47.5455 25.3182 48.1477 25.3182C48.6534 25.3182 49.0767 25.2557 49.4176 25.1307C49.7585 25.0057 50.017 24.8324 50.1932 24.6108C50.3693 24.3892 50.4602 24.1364 50.4659 23.8523C50.4602 23.5852 50.3722 23.3523 50.2017 23.1534C50.0369 22.9489 49.7642 22.767 49.3835 22.608C49.0028 22.4432 48.4886 22.2898 47.8409 22.1477L46.1023 21.7727C44.5568 21.4375 43.3381 20.8778 42.446 20.0938C41.5597 19.304 41.1193 18.2273 41.125 16.8636C41.1193 15.7557 41.4148 14.7869 42.0114 13.9574C42.6136 13.1222 43.446 12.4716 44.5085 12.0057C45.5767 11.5398 46.8011 11.3068 48.1818 11.3068C49.5909 11.3068 50.8097 11.5426 51.8381 12.0142C52.8665 12.4858 53.6591 13.1506 54.2159 14.0085C54.7784 14.8608 55.0625 15.858 55.0682 17H50.5341ZM57.1094 29V11.5455H61.848V18.6023H62.0866L67.3366 11.5455H72.8594L66.9616 19.3182L72.9957 29H67.3366L63.4162 22.4545L61.848 24.5V29H57.1094ZM79.0043 11.5455V29H74.2656V11.5455H79.0043ZM96.3523 11.5455V29H92.3977L86.0909 19.8295H85.9886V29H81.25V11.5455H85.2727L91.4773 20.6818H91.6136V11.5455H96.3523Z"
						fill="white"
					/>
					<path
						d="M108.003 17C107.957 16.4318 107.744 15.9886 107.364 15.6705C106.989 15.3523 106.418 15.1932 105.651 15.1932C105.162 15.1932 104.761 15.2528 104.449 15.3722C104.142 15.4858 103.915 15.642 103.767 15.8409C103.619 16.0398 103.543 16.267 103.537 16.5227C103.526 16.733 103.563 16.9233 103.648 17.0938C103.739 17.2585 103.881 17.4091 104.074 17.5455C104.267 17.6761 104.514 17.7955 104.815 17.9034C105.116 18.0114 105.474 18.108 105.889 18.1932L107.321 18.5C108.287 18.7045 109.114 18.9744 109.801 19.3097C110.489 19.6449 111.051 20.0398 111.489 20.4943C111.926 20.9432 112.247 21.4489 112.452 22.0114C112.662 22.5739 112.77 23.1875 112.776 23.8523C112.77 25 112.483 25.9716 111.915 26.767C111.347 27.5625 110.534 28.1676 109.477 28.5824C108.426 28.9972 107.162 29.2045 105.685 29.2045C104.168 29.2045 102.844 28.9801 101.713 28.5312C100.588 28.0824 99.7131 27.392 99.0881 26.4602C98.4688 25.5227 98.1563 24.3239 98.1506 22.8636H102.651C102.679 23.3977 102.813 23.8466 103.051 24.2102C103.29 24.5739 103.625 24.8494 104.057 25.0369C104.494 25.2244 105.014 25.3182 105.616 25.3182C106.122 25.3182 106.545 25.2557 106.886 25.1307C107.227 25.0057 107.486 24.8324 107.662 24.6108C107.838 24.3892 107.929 24.1364 107.935 23.8523C107.929 23.5852 107.841 23.3523 107.67 23.1534C107.506 22.9489 107.233 22.767 106.852 22.608C106.472 22.4432 105.957 22.2898 105.31 22.1477L103.571 21.7727C102.026 21.4375 100.807 20.8778 99.9148 20.0938C99.0284 19.304 98.5881 18.2273 98.5938 16.8636C98.5881 15.7557 98.8835 14.7869 99.4801 13.9574C100.082 13.1222 100.915 12.4716 101.977 12.0057C103.045 11.5398 104.27 11.3068 105.651 11.3068C107.06 11.3068 108.278 11.5426 109.307 12.0142C110.335 12.4858 111.128 13.1506 111.685 14.0085C112.247 14.8608 112.531 15.858 112.537 17H108.003ZM114.578 11.5455H120.476L124.533 21.4318H124.737L128.794 11.5455H134.692V29H130.055V18.9091H129.919L126.033 28.8636H123.237L119.351 18.8409H119.214V29H114.578V11.5455ZM153.847 20.2727C153.847 22.2159 153.469 23.8551 152.713 25.1903C151.957 26.5199 150.938 27.5284 149.653 28.2159C148.369 28.8977 146.938 29.2386 145.358 29.2386C143.767 29.2386 142.33 28.8949 141.045 28.2074C139.767 27.5142 138.75 26.5028 137.994 25.1733C137.244 23.8381 136.869 22.2045 136.869 20.2727C136.869 18.3295 137.244 16.6932 137.994 15.3636C138.75 14.0284 139.767 13.0199 141.045 12.3381C142.33 11.6506 143.767 11.3068 145.358 11.3068C146.938 11.3068 148.369 11.6506 149.653 12.3381C150.938 13.0199 151.957 14.0284 152.713 15.3636C153.469 16.6932 153.847 18.3295 153.847 20.2727ZM148.972 20.2727C148.972 19.2273 148.832 18.3466 148.554 17.6307C148.281 16.9091 147.875 16.3636 147.335 15.9943C146.801 15.6193 146.142 15.4318 145.358 15.4318C144.574 15.4318 143.912 15.6193 143.372 15.9943C142.838 16.3636 142.432 16.9091 142.153 17.6307C141.881 18.3466 141.744 19.2273 141.744 20.2727C141.744 21.3182 141.881 22.2017 142.153 22.9233C142.432 23.6392 142.838 24.1847 143.372 24.5597C143.912 24.929 144.574 25.1136 145.358 25.1136C146.142 25.1136 146.801 24.929 147.335 24.5597C147.875 24.1847 148.281 23.6392 148.554 22.9233C148.832 22.2017 148.972 21.3182 148.972 20.2727ZM156.039 29V11.5455H160.778V18.6023H161.016L166.266 11.5455H171.789L165.891 19.3182L171.925 29H166.266L162.346 22.4545L160.778 24.5V29H156.039ZM173.195 29V11.5455H185.775V15.3636H177.934V18.3636H185.127V22.1818H177.934V25.1818H185.741V29H173.195Z"
						fill="#9F2C2C"
					/>
					<defs>
						<clipPath id="clip0_51_1427">
							<rect width="40" height="40" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</router-link>
			<router-link v-else to="/" class="header__logo header__logo_dark">
				<svg
					width="187"
					height="40"
					viewBox="0 0 187 40"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_51_411)">
						<mask id="path-1-inside-1_51_411" fill="white">
							<path
								d="M14.4744 0.727686C17.28 -0.293423 20.3447 0.859705 21.8294 3.32458C21.8523 3.36251 21.901 3.37616 21.9402 3.35573C22.0987 3.2733 22.2647 3.20066 22.4371 3.1379C24.5615 2.36469 26.9109 3.46025 27.6841 5.58462C28.4572 7.70893 27.3614 10.0575 25.2371 10.8307C23.9274 11.3074 22.5329 11.0738 21.4744 10.3268C21.4382 10.3013 21.3882 10.3082 21.3605 10.3427C20.6811 11.1901 19.7696 11.8688 18.6745 12.2674C16.9502 12.895 15.1276 12.7015 13.6339 11.8872C13.5774 11.8564 13.5075 11.8985 13.5069 11.9629C13.496 13.2904 12.6736 14.5326 11.3527 15.0133C11.1148 15.0999 10.8732 15.1563 10.6321 15.1859C10.5819 15.192 10.5479 15.2409 10.5589 15.2903C10.8242 16.4766 10.1757 17.704 9.00292 18.131C7.72841 18.5949 6.31902 17.9375 5.85496 16.6631C5.39103 15.3885 6.04825 13.979 7.32288 13.5151C7.34019 13.5088 7.34824 13.4893 7.33963 13.473C7.26961 13.3405 7.20861 13.2011 7.15587 13.0563C6.53732 11.3568 7.41314 9.47712 9.11257 8.85851C9.6464 8.66422 10.1981 8.61793 10.7228 8.69788C10.7791 8.70645 10.8237 8.65167 10.8043 8.5982C9.64446 5.41165 11.2878 1.8875 14.4744 0.727686Z"
							/>
						</mask>
						<path
							d="M14.4744 0.727686C17.28 -0.293423 20.3447 0.859705 21.8294 3.32458C21.8523 3.36251 21.901 3.37616 21.9402 3.35573C22.0987 3.2733 22.2647 3.20066 22.4371 3.1379C24.5615 2.36469 26.9109 3.46025 27.6841 5.58462C28.4572 7.70893 27.3614 10.0575 25.2371 10.8307C23.9274 11.3074 22.5329 11.0738 21.4744 10.3268C21.4382 10.3013 21.3882 10.3082 21.3605 10.3427C20.6811 11.1901 19.7696 11.8688 18.6745 12.2674C16.9502 12.895 15.1276 12.7015 13.6339 11.8872C13.5774 11.8564 13.5075 11.8985 13.5069 11.9629C13.496 13.2904 12.6736 14.5326 11.3527 15.0133C11.1148 15.0999 10.8732 15.1563 10.6321 15.1859C10.5819 15.192 10.5479 15.2409 10.5589 15.2903C10.8242 16.4766 10.1757 17.704 9.00292 18.131C7.72841 18.5949 6.31902 17.9375 5.85496 16.6631C5.39103 15.3885 6.04825 13.979 7.32288 13.5151C7.34019 13.5088 7.34824 13.4893 7.33963 13.473C7.26961 13.3405 7.20861 13.2011 7.15587 13.0563C6.53732 11.3568 7.41314 9.47712 9.11257 8.85851C9.6464 8.66422 10.1981 8.61793 10.7228 8.69788C10.7791 8.70645 10.8237 8.65167 10.8043 8.5982C9.64446 5.41165 11.2878 1.8875 14.4744 0.727686Z"
							fill="white"
						/>
						<path
							d="M14.4744 0.727686L14.3033 0.257837L14.3033 0.257839L14.4744 0.727686ZM22.4371 3.1379L22.2661 2.66805L22.4371 3.1379ZM27.6841 5.58462L28.154 5.41364L28.154 5.41361L27.6841 5.58462ZM25.2371 10.8307L25.4081 11.3006L25.2371 10.8307ZM18.6745 12.2674L18.8455 12.7372L18.8455 12.7372L18.6745 12.2674ZM11.3527 15.0133L11.5237 15.4832L11.5237 15.4832L11.3527 15.0133ZM9.00292 18.131L9.17393 18.6008L9.17396 18.6008L9.00292 18.131ZM5.85496 16.6631L5.38511 16.8341L5.38514 16.8342L5.85496 16.6631ZM7.32288 13.5151L7.1519 13.0453L7.15187 13.0453L7.32288 13.5151ZM7.15587 13.0563L6.68603 13.2273L6.68604 13.2273L7.15587 13.0563ZM9.11257 8.85851L8.94156 8.38867L8.94154 8.38867L9.11257 8.85851ZM10.8043 8.5982L10.3344 8.76921L10.3344 8.76923L10.8043 8.5982ZM7.33963 13.473L6.89755 13.7066L7.33963 13.473ZM10.6321 15.1859L10.5712 14.6896L10.6321 15.1859ZM13.6339 11.8872L13.3946 12.3263L13.6339 11.8872ZM13.5069 11.9629L14.0069 11.967L13.5069 11.9629ZM10.7228 8.69788L10.6475 9.19217L10.7228 8.69788ZM21.4744 10.3268L21.7626 9.91831L21.4744 10.3268ZM21.3605 10.3427L20.9704 10.03L21.3605 10.3427ZM21.8294 3.32458L22.2577 3.0666L21.8294 3.32458ZM21.9402 3.35573L21.7095 2.91213L21.9402 3.35573ZM14.4744 0.727686L14.6454 1.19753C17.2217 0.259881 20.0373 1.31835 21.4011 3.58257L21.8294 3.32458L22.2577 3.0666C20.6522 0.401062 17.3383 -0.846728 14.3033 0.257837L14.4744 0.727686ZM21.9402 3.35573L22.1709 3.79932C22.3094 3.72732 22.4553 3.66336 22.6081 3.60774L22.4371 3.1379L22.2661 2.66805C22.074 2.73796 21.8881 2.81927 21.7095 2.91213L21.9402 3.35573ZM22.4371 3.1379L22.6081 3.60774C24.473 2.92898 26.5355 3.89075 27.2143 5.75563L27.6841 5.58462L28.154 5.41361C27.2863 3.02975 24.65 1.8004 22.2661 2.66805L22.4371 3.1379ZM27.6841 5.58462L27.2143 5.7556C27.8928 7.62032 26.931 9.68209 25.0661 10.3609L25.2371 10.8307L25.4081 11.3006C27.7917 10.433 29.0215 7.79754 28.154 5.41364L27.6841 5.58462ZM25.2371 10.8307L25.0661 10.3609C23.9168 10.7791 22.6931 10.5749 21.7626 9.91831L21.4744 10.3268L21.1861 10.7354C22.3726 11.5726 23.938 11.8356 25.4081 11.3006L25.2371 10.8307ZM21.3605 10.3427L20.9704 10.03C20.3464 10.8083 19.5097 11.4312 18.5034 11.7975L18.6745 12.2674L18.8455 12.7372C20.0295 12.3063 21.0159 11.5719 21.7506 10.6555L21.3605 10.3427ZM18.6745 12.2674L18.5034 11.7975C16.9197 12.3739 15.2463 12.1967 13.8732 11.4482L13.6339 11.8872L13.3946 12.3263C15.0088 13.2062 16.9806 13.416 18.8455 12.7372L18.6745 12.2674ZM13.5069 11.9629L13.007 11.9588C12.9977 13.0847 12.2999 14.1365 11.1817 14.5435L11.3527 15.0133L11.5237 15.4832C13.0473 14.9286 13.9943 13.4961 14.0069 11.967L13.5069 11.9629ZM11.3527 15.0133L11.1817 14.5435C10.9806 14.6167 10.7761 14.6644 10.5712 14.6896L10.6321 15.1859L10.6931 15.6821C10.9703 15.6481 11.2489 15.5832 11.5237 15.4832L11.3527 15.0133ZM10.5589 15.2903L10.071 15.3994C10.2823 16.3442 9.76507 17.3214 8.83187 17.6612L9.00292 18.131L9.17396 18.6008C10.5864 18.0866 11.3662 16.609 11.0469 15.1812L10.5589 15.2903ZM9.00292 18.131L8.83191 17.6612C7.81696 18.0306 6.6944 17.507 6.32478 16.492L5.85496 16.6631L5.38514 16.8342C5.94363 18.3679 7.63986 19.1592 9.17393 18.6008L9.00292 18.131ZM5.85496 16.6631L6.32481 16.4921C5.95533 15.4769 6.47875 14.3544 7.49389 13.985L7.32288 13.5151L7.15187 13.0453C5.61775 13.6036 4.82674 15.3 5.38511 16.8341L5.85496 16.6631ZM7.33963 13.473L7.78172 13.2394C7.72326 13.1288 7.67132 13.0105 7.62571 12.8852L7.15587 13.0563L6.68604 13.2273C6.74589 13.3917 6.81595 13.5522 6.89755 13.7066L7.33963 13.473ZM7.15587 13.0563L7.62572 12.8853C7.10155 11.4451 7.8438 9.85245 9.28359 9.32835L9.11257 8.85851L8.94154 8.38867C6.98247 9.10179 5.97309 11.2685 6.68603 13.2273L7.15587 13.0563ZM9.11257 8.85851L9.28358 9.32836C9.73639 9.16355 10.2033 9.12449 10.6475 9.19217L10.7228 8.69788L10.7981 8.20358C10.193 8.11138 9.5564 8.16488 8.94156 8.38867L9.11257 8.85851ZM10.8043 8.5982L11.2741 8.42719C10.2088 5.50013 11.7183 2.2629 14.6454 1.19753L14.4744 0.727686L14.3033 0.257839C10.8573 1.5121 9.08017 5.32317 10.3344 8.76921L10.8043 8.5982ZM7.32288 13.5151L7.49385 13.985C7.78189 13.8802 7.93904 13.5372 7.78172 13.2394L7.33963 13.473L6.89755 13.7066C6.75745 13.4414 6.89849 13.1375 7.1519 13.0453L7.32288 13.5151ZM10.6321 15.1859L10.5712 14.6896C10.2236 14.7323 9.99639 15.0658 10.071 15.3994L10.5589 15.2903L11.0469 15.1812C11.0994 15.416 10.9402 15.6518 10.6931 15.6821L10.6321 15.1859ZM13.6339 11.8872L13.8732 11.4482C13.477 11.2323 13.0105 11.526 13.007 11.9588L13.5069 11.9629L14.0069 11.967C14.0044 12.271 13.6777 12.4806 13.3946 12.3263L13.6339 11.8872ZM10.7228 8.69788L10.6475 9.19217C11.0813 9.25827 11.4227 8.83547 11.2741 8.42718L10.8043 8.5982L10.3344 8.76923C10.2247 8.46787 10.4769 8.15463 10.7981 8.20358L10.7228 8.69788ZM21.4744 10.3268L21.7626 9.91831C21.5124 9.74171 21.1648 9.78748 20.9704 10.03L21.3605 10.3427L21.7506 10.6555C21.6116 10.8288 21.364 10.8609 21.1861 10.7354L21.4744 10.3268ZM21.8294 3.32458L21.4011 3.58257C21.5606 3.84733 21.8981 3.9412 22.1709 3.79932L21.9402 3.35573L21.7095 2.91213C21.9038 2.81112 22.1439 2.8777 22.2577 3.0666L21.8294 3.32458Z"
							fill="#232323"
							mask="url(#path-1-inside-1_51_411)"
						/>
						<path
							d="M17.4692 18.5951L16.1799 17.6476C16.1668 17.6381 16.1569 17.6249 16.1514 17.6097L16.1098 17.4955C16.0944 17.453 16.1163 17.406 16.1588 17.3906L18.3829 16.581C18.4254 16.5656 18.4473 16.5186 18.4319 16.4761L18.2467 15.9672C18.2312 15.9247 18.1842 15.9028 18.1417 15.9183L14.8714 17.1086C14.8553 17.1145 14.8414 17.1253 14.8319 17.1397C14.7809 17.2176 14.6104 17.4863 14.5472 17.6902C14.4385 18.0407 14.4081 18.278 14.5138 18.6294C14.5325 18.6915 14.5706 18.7854 14.5706 18.7854C14.7091 19.2751 13.5845 18.0557 13.5028 17.9667C13.4994 17.963 13.4969 17.9596 13.4943 17.9553C13.4575 17.8947 13.1723 17.4136 13.1718 17.065C13.1716 16.9382 13.1845 16.8669 13.2089 16.7424C13.2639 16.4619 13.4706 16.0844 13.5274 15.9843C13.5367 15.9677 13.5516 15.9555 13.5695 15.949L20.3031 13.4981C20.3175 13.4929 20.3328 13.4918 20.3477 13.4952C20.4941 13.529 21.3095 13.733 21.603 14.1508C21.7846 14.4093 21.8284 14.5992 21.8797 14.911C21.92 15.1562 21.9309 15.302 21.8905 15.5472C21.8184 15.9847 21.3648 16.5032 21.2346 16.6445C21.2133 16.6676 21.2065 16.7004 21.2173 16.7299L21.9379 18.7098C21.9534 18.7523 21.9315 18.7993 21.889 18.8147L18.2932 20.1235C18.2537 20.1379 18.2096 20.1199 18.1914 20.0819L17.4946 18.6258C17.4888 18.6136 17.4801 18.6031 17.4692 18.5951Z"
							fill="white"
							stroke="#232323"
							stroke-width="0.5"
						/>
						<path
							d="M27.4567 22.6375L16.528 26.6152C16.4745 26.6347 16.4179 26.595 16.4181 26.538L16.4245 24.2281C16.4246 24.1989 16.4394 24.1724 16.4644 24.1574C16.6741 24.0307 17.6567 23.414 18.0099 22.7708C18.2529 22.3282 18.3605 21.5767 18.3857 21.3767C18.3896 21.3457 18.4103 21.3198 18.4396 21.3091L22.6305 19.7837C22.6424 19.7794 22.655 19.7779 22.6675 19.7794C22.8573 19.8022 24.426 20.002 25.3126 20.4739C26.2326 20.9636 27.2293 22.1782 27.4936 22.5129C27.5277 22.5562 27.5085 22.6186 27.4567 22.6375Z"
							fill="white"
							stroke="#232323"
							stroke-width="0.5"
						/>
						<path
							d="M30.5427 37.4465L23.8696 39.8753C23.8426 39.8852 23.8124 39.8801 23.7901 39.8621L20.762 37.4125C20.7125 37.3725 20.7256 37.2937 20.7855 37.2719L31.2318 33.4698C31.2917 33.448 31.3524 33.4999 31.3402 33.5624L30.5951 37.3853C30.5896 37.4134 30.5697 37.4367 30.5427 37.4465Z"
							fill="white"
							stroke="#232323"
							stroke-width="0.5"
						/>
						<path
							d="M31.2326 32.088L19.7667 36.2612C19.7304 36.2744 19.6894 36.2598 19.669 36.227C17.7501 33.1516 17.1 31.3281 16.6764 28.0068C16.6715 27.9689 16.6935 27.932 16.7294 27.919L28.1979 23.7448C28.2328 23.7321 28.2723 23.7451 28.2935 23.7757C30.2114 26.5512 30.8487 28.3875 31.2858 32.0005C31.2903 32.0383 31.2683 32.075 31.2326 32.088Z"
							fill="white"
							stroke="#232323"
							stroke-width="0.5"
						/>
						<circle
							cx="20.3003"
							cy="15.5256"
							r="0.736807"
							transform="rotate(-20 20.3003 15.5256)"
							fill="#232323"
						/>
					</g>
					<path
						d="M50.5341 17C50.4886 16.4318 50.2756 15.9886 49.8949 15.6705C49.5199 15.3523 48.9489 15.1932 48.1818 15.1932C47.6932 15.1932 47.2926 15.2528 46.9801 15.3722C46.6733 15.4858 46.446 15.642 46.2983 15.8409C46.1506 16.0398 46.0739 16.267 46.0682 16.5227C46.0568 16.733 46.0938 16.9233 46.179 17.0938C46.2699 17.2585 46.4119 17.4091 46.6051 17.5455C46.7983 17.6761 47.0455 17.7955 47.3466 17.9034C47.6477 18.0114 48.0057 18.108 48.4205 18.1932L49.8523 18.5C50.8182 18.7045 51.6449 18.9744 52.3324 19.3097C53.0199 19.6449 53.5824 20.0398 54.0199 20.4943C54.4574 20.9432 54.7784 21.4489 54.983 22.0114C55.1932 22.5739 55.3011 23.1875 55.3068 23.8523C55.3011 25 55.0142 25.9716 54.446 26.767C53.8778 27.5625 53.0653 28.1676 52.0085 28.5824C50.9574 28.9972 49.6932 29.2045 48.2159 29.2045C46.6989 29.2045 45.375 28.9801 44.2443 28.5312C43.1193 28.0824 42.2443 27.392 41.6193 26.4602C41 25.5227 40.6875 24.3239 40.6818 22.8636H45.1818C45.2102 23.3977 45.3438 23.8466 45.5824 24.2102C45.821 24.5739 46.1563 24.8494 46.5881 25.0369C47.0256 25.2244 47.5455 25.3182 48.1477 25.3182C48.6534 25.3182 49.0767 25.2557 49.4176 25.1307C49.7585 25.0057 50.017 24.8324 50.1932 24.6108C50.3693 24.3892 50.4602 24.1364 50.4659 23.8523C50.4602 23.5852 50.3722 23.3523 50.2017 23.1534C50.0369 22.9489 49.7642 22.767 49.3835 22.608C49.0028 22.4432 48.4886 22.2898 47.8409 22.1477L46.1023 21.7727C44.5568 21.4375 43.3381 20.8778 42.446 20.0938C41.5597 19.304 41.1193 18.2273 41.125 16.8636C41.1193 15.7557 41.4148 14.7869 42.0114 13.9574C42.6136 13.1222 43.446 12.4716 44.5085 12.0057C45.5767 11.5398 46.8011 11.3068 48.1818 11.3068C49.5909 11.3068 50.8097 11.5426 51.8381 12.0142C52.8665 12.4858 53.6591 13.1506 54.2159 14.0085C54.7784 14.8608 55.0625 15.858 55.0682 17H50.5341ZM57.1094 29V11.5455H61.848V18.6023H62.0866L67.3366 11.5455H72.8594L66.9616 19.3182L72.9957 29H67.3366L63.4162 22.4545L61.848 24.5V29H57.1094ZM79.0043 11.5455V29H74.2656V11.5455H79.0043ZM96.3523 11.5455V29H92.3977L86.0909 19.8295H85.9886V29H81.25V11.5455H85.2727L91.4773 20.6818H91.6136V11.5455H96.3523Z"
						fill="white"
					/>
					<path
						d="M108.003 17C107.957 16.4318 107.744 15.9886 107.364 15.6705C106.989 15.3523 106.418 15.1932 105.651 15.1932C105.162 15.1932 104.761 15.2528 104.449 15.3722C104.142 15.4858 103.915 15.642 103.767 15.8409C103.619 16.0398 103.543 16.267 103.537 16.5227C103.526 16.733 103.563 16.9233 103.648 17.0938C103.739 17.2585 103.881 17.4091 104.074 17.5455C104.267 17.6761 104.514 17.7955 104.815 17.9034C105.116 18.0114 105.474 18.108 105.889 18.1932L107.321 18.5C108.287 18.7045 109.114 18.9744 109.801 19.3097C110.489 19.6449 111.051 20.0398 111.489 20.4943C111.926 20.9432 112.247 21.4489 112.452 22.0114C112.662 22.5739 112.77 23.1875 112.776 23.8523C112.77 25 112.483 25.9716 111.915 26.767C111.347 27.5625 110.534 28.1676 109.477 28.5824C108.426 28.9972 107.162 29.2045 105.685 29.2045C104.168 29.2045 102.844 28.9801 101.713 28.5312C100.588 28.0824 99.7131 27.392 99.0881 26.4602C98.4688 25.5227 98.1563 24.3239 98.1506 22.8636H102.651C102.679 23.3977 102.813 23.8466 103.051 24.2102C103.29 24.5739 103.625 24.8494 104.057 25.0369C104.494 25.2244 105.014 25.3182 105.616 25.3182C106.122 25.3182 106.545 25.2557 106.886 25.1307C107.227 25.0057 107.486 24.8324 107.662 24.6108C107.838 24.3892 107.929 24.1364 107.935 23.8523C107.929 23.5852 107.841 23.3523 107.67 23.1534C107.506 22.9489 107.233 22.767 106.852 22.608C106.472 22.4432 105.957 22.2898 105.31 22.1477L103.571 21.7727C102.026 21.4375 100.807 20.8778 99.9148 20.0938C99.0284 19.304 98.5881 18.2273 98.5938 16.8636C98.5881 15.7557 98.8835 14.7869 99.4801 13.9574C100.082 13.1222 100.915 12.4716 101.977 12.0057C103.045 11.5398 104.27 11.3068 105.651 11.3068C107.06 11.3068 108.278 11.5426 109.307 12.0142C110.335 12.4858 111.128 13.1506 111.685 14.0085C112.247 14.8608 112.531 15.858 112.537 17H108.003ZM114.578 11.5455H120.476L124.533 21.4318H124.737L128.794 11.5455H134.692V29H130.055V18.9091H129.919L126.033 28.8636H123.237L119.351 18.8409H119.214V29H114.578V11.5455ZM153.847 20.2727C153.847 22.2159 153.469 23.8551 152.713 25.1903C151.957 26.5199 150.938 27.5284 149.653 28.2159C148.369 28.8977 146.938 29.2386 145.358 29.2386C143.767 29.2386 142.33 28.8949 141.045 28.2074C139.767 27.5142 138.75 26.5028 137.994 25.1733C137.244 23.8381 136.869 22.2045 136.869 20.2727C136.869 18.3295 137.244 16.6932 137.994 15.3636C138.75 14.0284 139.767 13.0199 141.045 12.3381C142.33 11.6506 143.767 11.3068 145.358 11.3068C146.938 11.3068 148.369 11.6506 149.653 12.3381C150.938 13.0199 151.957 14.0284 152.713 15.3636C153.469 16.6932 153.847 18.3295 153.847 20.2727ZM148.972 20.2727C148.972 19.2273 148.832 18.3466 148.554 17.6307C148.281 16.9091 147.875 16.3636 147.335 15.9943C146.801 15.6193 146.142 15.4318 145.358 15.4318C144.574 15.4318 143.912 15.6193 143.372 15.9943C142.838 16.3636 142.432 16.9091 142.153 17.6307C141.881 18.3466 141.744 19.2273 141.744 20.2727C141.744 21.3182 141.881 22.2017 142.153 22.9233C142.432 23.6392 142.838 24.1847 143.372 24.5597C143.912 24.929 144.574 25.1136 145.358 25.1136C146.142 25.1136 146.801 24.929 147.335 24.5597C147.875 24.1847 148.281 23.6392 148.554 22.9233C148.832 22.2017 148.972 21.3182 148.972 20.2727ZM156.039 29V11.5455H160.778V18.6023H161.016L166.266 11.5455H171.789L165.891 19.3182L171.925 29H166.266L162.346 22.4545L160.778 24.5V29H156.039ZM173.195 29V11.5455H185.775V15.3636H177.934V18.3636H185.127V22.1818H177.934V25.1818H185.741V29H173.195Z"
						fill="#232323"
					/>
					<defs>
						<clipPath id="clip0_51_411">
							<rect width="40" height="40" fill="white" />
						</clipPath>
					</defs>
				</svg>
			</router-link>
			<nav class="header__nav nav" :class="{ 'menu-open': menuVisible }">
				<ul class="nav__list">
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{ nav__link_active: $route.path === '/' }"
							to="/"
							>{{ $t('Home') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active:
									$route.path === '/products/all' &&
									$route.query.special_offers !== 'sale',
							}"
							:to="{
								name: 'ProductListPage',
								params: { itemType: 'all' },
							}"
							>{{ $t('Market') }}</router-link
						>
					</li>
					<li class="nav__item">
						<router-link
							class="nav__link _header-link"
							:class="{
								nav__link_active:
									$route.name === 'ProductListPage' &&
									$route.params.itemType === 'all' &&
									$route.query.special_offers === 'sale',
							}"
							to="/products/all?special_offers=sale"
							>{{ $t('Deals') }}</router-link
						>
					</li>
					<li class="nav__item" @click="sellSkin">
						<a class="nav__link _header-link">{{ $t('Sell skin') }}</a>
					</li>
				</ul>
			</nav>
			<div class="header__options" data-da=".header__nav,767.98">
				<div
					v-if="currencyOptions && currencyOptions.length > 1"
					class="header__options-wrapper select-wrapper"
				>
					<select
						class="_select"
						v-model="selectedCurrency"
						@change="handleCurrencyChange"
					>
						<option
							v-for="opt in currencyOptions"
							:key="opt.id"
							:value="opt.id"
						>
							{{ opt.text }}
						</option>
					</select>
				</div>
				<div
					v-if="languages && languages.length > 1"
					class="header__options-wrapper select-wrapper"
				>
					<select
						class="_select"
						v-model="selectedLanguage"
						@change="handleLanguageChange"
					>
						<option
							v-for="opt in languageOptions"
							:key="opt.id"
							:value="opt.id"
						>
							{{ opt.text }}
						</option>
					</select>
				</div>
			</div>
			<div v-if="isAuth" class="header__user-menu user-menu">
				<router-link
					to="/profile/my-balance"
					class="user-menu__link user-menu__wallet wallet"
					data-da=".header__nav,479.98"
				>
					<p class="wallet__amount">
						{{ (userBalance).toFixed(2) }}
					</p>
					<div class="wallet__icon _svg-icon">
						<svg
							width="19"
							height="19"
							viewBox="0 0 19 19"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M9.16667 18.3333C14.2293 18.3333 18.3333 14.2293 18.3333 9.16667C18.3333 4.10406 14.2293 0 9.16667 0C4.10406 0 0 4.10406 0 9.16667C0 14.2293 4.10406 18.3333 9.16667 18.3333Z"
								fill="#FFE180"
							/>
							<path
								d="M9.16634 16.5C13.2164 16.5 16.4997 13.2168 16.4997 9.16667C16.4997 5.11658 13.2164 1.83333 9.16634 1.83333C5.11625 1.83333 1.83301 5.11658 1.83301 9.16667C1.83301 13.2168 5.11625 16.5 9.16634 16.5Z"
								fill="#FFB030"
							/>
							<path
								d="M9.16699 16.0417C12.964 16.0417 16.042 12.9636 16.042 9.16667C16.042 5.36971 12.964 2.29167 9.16699 2.29167C5.37003 2.29167 2.29199 5.36971 2.29199 9.16667C2.29199 12.9636 5.37003 16.0417 9.16699 16.0417Z"
								fill="#FFC926"
							/>
							<path
								d="M4.06861 9.16337C4.06861 9.31863 3.94152 9.44567 3.78626 9.44567C3.63099 9.44567 3.50391 9.31863 3.50391 9.16337C3.50391 9.00104 3.63099 8.88102 3.78626 8.88102C3.94152 8.88102 4.06861 9.00104 4.06861 9.16337Z"
								fill="white"
							/>
							<path
								d="M4.87364 6.68588C4.95132 6.55177 5.12071 6.50942 5.25482 6.58705C5.38893 6.66469 5.43835 6.83412 5.36067 6.96823C5.28304 7.10234 5.11365 7.15171 4.97247 7.07408C4.83836 6.99646 4.79602 6.82 4.87364 6.68588Z"
								fill="white"
							/>
							<path
								d="M5.37408 11.3726C5.45171 11.5067 5.40936 11.6761 5.27525 11.7608C5.14115 11.8385 4.96469 11.789 4.88705 11.6549C4.80942 11.5208 4.85177 11.3514 4.99295 11.2667C5.12706 11.1891 5.29645 11.2385 5.37408 11.3726Z"
								fill="white"
							/>
							<path
								d="M6.02377 9.16336C6.02377 9.3963 5.84024 9.58685 5.60028 9.58685C5.36735 9.58685 5.17676 9.3963 5.17676 9.16336C5.17676 8.92336 5.36735 8.73984 5.60028 8.73984C5.84024 8.73984 6.02377 8.92336 6.02377 9.16336Z"
								fill="white"
							/>
							<path
								d="M6.7368 13.963C6.66624 14.0971 6.48978 14.1395 6.35567 14.0689C6.22156 13.9913 6.17215 13.8148 6.24978 13.6807C6.32741 13.5466 6.49685 13.4972 6.63798 13.5748C6.77209 13.6525 6.81443 13.8219 6.7368 13.963Z"
								fill="white"
							/>
							<path
								d="M6.24294 4.63896C6.16531 4.50485 6.21473 4.32839 6.34884 4.25076C6.48294 4.17313 6.6594 4.22253 6.73704 4.35664C6.81467 4.49075 6.76525 4.66721 6.63119 4.74484C6.49707 4.82247 6.32061 4.77307 6.24294 4.63896Z"
								fill="white"
							/>
							<path
								d="M6.89883 7.37052C7.10355 7.48348 7.17411 7.74463 7.05414 7.94931C6.94118 8.15403 6.68003 8.21753 6.47535 8.10462C6.27067 7.98463 6.20713 7.73051 6.32008 7.52583C6.44006 7.32115 6.69415 7.25054 6.89883 7.37052Z"
								fill="white"
							/>
							<path
								d="M6.913 10.9632C6.70832 11.0832 6.45423 11.0126 6.33421 10.808C6.21422 10.6103 6.28479 10.3492 6.48245 10.2292C6.68712 10.1162 6.94828 10.1798 7.0683 10.3844C7.18122 10.5892 7.11767 10.8433 6.913 10.9632Z"
								fill="white"
							/>
							<path
								d="M7.46365 9.86242C7.85347 9.86242 8.16948 9.5464 8.16948 9.15658C8.16948 8.76676 7.85347 8.45075 7.46365 8.45075C7.07383 8.45075 6.75781 8.76676 6.75781 9.15658C6.75781 9.5464 7.07383 9.86242 7.46365 9.86242Z"
								fill="white"
							/>
							<path
								d="M7.76038 12.4525C7.64742 12.6573 7.38627 12.7278 7.18865 12.6149C6.98398 12.4949 6.91337 12.2337 7.02633 12.0361C7.14631 11.8314 7.4004 11.7608 7.60508 11.8737C7.80979 11.9938 7.88035 12.2479 7.76038 12.4525Z"
								fill="white"
							/>
							<path
								d="M7.02635 6.28356C6.90633 6.07888 6.97694 5.82479 7.18161 5.70476C7.38629 5.59185 7.64042 5.66241 7.7604 5.86007C7.87332 6.06474 7.80275 6.3259 7.59808 6.43886C7.40042 6.55884 7.13926 6.48823 7.02635 6.28356Z"
								fill="white"
							/>
							<path
								d="M8.31033 11.33C8.70015 11.33 9.01616 11.014 9.01616 10.6242C9.01616 10.2343 8.70015 9.91833 8.31033 9.91833C7.9205 9.91833 7.60449 10.2343 7.60449 10.6242C7.60449 11.014 7.9205 11.33 8.31033 11.33Z"
								fill="white"
							/>
							<path
								d="M8.31033 8.39392C8.70015 8.39392 9.01616 8.0779 9.01616 7.68808C9.01616 7.29826 8.70015 6.98225 8.31033 6.98225C7.9205 6.98225 7.60449 7.29826 7.60449 7.68808C7.60449 8.0779 7.9205 8.39392 8.31033 8.39392Z"
								fill="white"
							/>
							<path
								d="M9.58138 12.0008C9.58138 12.2337 9.39079 12.4243 9.15786 12.4243C8.92496 12.4243 8.73438 12.2337 8.73438 12.0008C8.73438 11.7679 8.92497 11.5773 9.15786 11.5773C9.39079 11.5773 9.58138 11.7679 9.58138 12.0008Z"
								fill="white"
							/>
							<path
								d="M8.73438 6.33297C8.73438 6.10003 8.92497 5.90948 9.15786 5.90948C9.39079 5.90948 9.58138 6.10003 9.58138 6.33297C9.58138 6.5659 9.39079 6.75646 9.15786 6.75646C8.92496 6.75646 8.73438 6.56591 8.73438 6.33297Z"
								fill="white"
							/>
							<path
								d="M9.43966 13.8148C9.43966 13.9701 9.31262 14.0971 9.15731 14.0971C9.00204 14.0971 8.875 13.9701 8.875 13.8148C8.875 13.6595 9.00204 13.5325 9.15731 13.5325C9.31261 13.5325 9.43966 13.6595 9.43966 13.8148Z"
								fill="white"
							/>
							<path
								d="M8.875 4.51897C8.875 4.36371 9.00204 4.23667 9.15731 4.23667C9.31262 4.23667 9.43966 4.36371 9.43966 4.51897C9.43966 4.67428 9.31262 4.80133 9.15731 4.80133C9.00204 4.80133 8.875 4.67428 8.875 4.51897Z"
								fill="white"
							/>
							<path
								d="M9.99685 11.33C10.3867 11.33 10.7027 11.014 10.7027 10.6242C10.7027 10.2343 10.3867 9.91833 9.99685 9.91833C9.60703 9.91833 9.29102 10.2343 9.29102 10.6242C9.29102 11.014 9.60703 11.33 9.99685 11.33Z"
								fill="white"
							/>
							<path
								d="M9.99685 8.39392C10.3867 8.39392 10.7027 8.0779 10.7027 7.68808C10.7027 7.29826 10.3867 6.98225 9.99685 6.98225C9.60703 6.98225 9.29102 7.29826 9.29102 7.68808C9.29102 8.0779 9.60703 8.39392 9.99685 8.39392Z"
								fill="white"
							/>
							<path
								d="M10.8513 9.86242C11.2412 9.86242 11.5572 9.5464 11.5572 9.15658C11.5572 8.76676 11.2412 8.45075 10.8513 8.45075C10.4615 8.45075 10.1455 8.76676 10.1455 9.15658C10.1455 9.5464 10.4615 9.86242 10.8513 9.86242Z"
								fill="white"
							/>
							<path
								d="M10.5478 5.86008C10.6678 5.65536 10.9219 5.58479 11.1266 5.70478C11.3313 5.81774 11.4018 6.07889 11.2819 6.28356C11.1689 6.48121 10.9078 6.55178 10.7101 6.43887C10.5055 6.31884 10.4349 6.06475 10.5478 5.86008Z"
								fill="white"
							/>
							<path
								d="M11.2889 12.029C11.4089 12.2337 11.3384 12.4949 11.1336 12.6078C10.929 12.7278 10.6678 12.6573 10.5549 12.4525C10.4419 12.2479 10.5125 11.9867 10.7102 11.8737C10.9148 11.7608 11.176 11.8314 11.2889 12.029Z"
								fill="white"
							/>
							<path
								d="M11.4023 7.34938C11.5999 7.23646 11.8611 7.29996 11.9811 7.50464C12.094 7.70229 12.0305 7.96345 11.8258 8.08343C11.6282 8.20345 11.367 8.13285 11.247 7.92817C11.1271 7.73051 11.1976 7.46935 11.4023 7.34938Z"
								fill="white"
							/>
							<path
								d="M11.416 10.9421C11.2113 10.8291 11.1407 10.568 11.2607 10.3633C11.3736 10.1656 11.6348 10.0951 11.8395 10.208C12.0371 10.328 12.1077 10.5892 11.9948 10.7868C11.8748 10.9914 11.6136 11.0621 11.416 10.9421Z"
								fill="white"
							/>
							<path
								d="M12.0659 13.6807C12.1436 13.8148 12.1012 13.9842 11.9671 14.0619C11.8259 14.1395 11.6566 14.0901 11.5789 13.956C11.5012 13.8219 11.5507 13.6525 11.6848 13.5748C11.8189 13.4972 11.9883 13.5395 12.0659 13.6807Z"
								fill="white"
							/>
							<path
								d="M11.5721 4.35664C11.6497 4.21547 11.8262 4.17312 11.9603 4.25075C12.0944 4.32838 12.1438 4.49782 12.0661 4.63193C11.9885 4.77306 11.812 4.81541 11.6779 4.73777C11.5438 4.66015 11.4944 4.49076 11.5721 4.35664Z"
								fill="white"
							/>
							<path
								d="M12.7077 9.57979C12.4748 9.57979 12.2842 9.38924 12.2842 9.15631C12.2842 8.92337 12.4748 8.73283 12.7077 8.73283C12.9406 8.73283 13.1312 8.92337 13.1312 9.15631C13.1312 9.38924 12.9406 9.57979 12.7077 9.57979Z"
								fill="white"
							/>
							<path
								d="M12.9334 6.93997C12.8557 6.80586 12.9051 6.63647 13.0393 6.55884C13.1734 6.48121 13.3428 6.52356 13.4275 6.65767C13.5051 6.79178 13.4557 6.96823 13.3216 7.04587C13.1875 7.1235 13.0181 7.08115 12.9334 6.93997Z"
								fill="white"
							/>
							<path
								d="M13.4417 11.6267C13.3641 11.7608 13.1947 11.8102 13.0535 11.7326C12.9194 11.6549 12.8771 11.4785 12.9547 11.3444C13.0323 11.2103 13.2018 11.1609 13.3359 11.2385C13.4699 11.3162 13.5194 11.4926 13.4417 11.6267Z"
								fill="white"
							/>
							<path
								d="M14.8117 9.1563C14.8117 9.31156 14.6847 9.43865 14.5294 9.43865C14.367 9.43865 14.2471 9.31156 14.2471 9.1563C14.2471 9.00103 14.3671 8.87395 14.5294 8.87395C14.6847 8.87396 14.8117 9.00104 14.8117 9.1563Z"
								fill="white"
							/>
						</svg>
					</div>
					<div class="wallet__more">+</div>
				</router-link>
				<div class="user-menu__actions">
					<router-link class="user-menu__link" to="/cart">
						<div class="user-menu__icon user-menu__icon_cart _svg-icon">
							<svg
								width="30"
								height="30"
								viewBox="0 0 30 30"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle cx="15" cy="15" r="15" fill="white" />
								<path
									d="M24.322 10.931C24.23 10.7981 24.1072 10.6894 23.964 10.6144C23.8209 10.5393 23.6616 10.5001 23.5 10.5H9.833L8.679 7.73001C8.52813 7.36492 8.27202 7.05299 7.94328 6.83394C7.61453 6.6149 7.22803 6.49865 6.833 6.50001H4.5V8.50001H6.833L11.577 19.885C11.653 20.0672 11.7812 20.2228 11.9454 20.3322C12.1097 20.4416 12.3026 20.5 12.5 20.5H20.5C20.917 20.5 21.29 20.241 21.437 19.852L24.437 11.852C24.4937 11.7006 24.5129 11.5378 24.4928 11.3774C24.4728 11.217 24.4142 11.0638 24.322 10.931Z"
									fill="#9F2C2C"
								/>
								<path
									d="M13 24.5C13.8284 24.5 14.5 23.8284 14.5 23C14.5 22.1716 13.8284 21.5 13 21.5C12.1716 21.5 11.5 22.1716 11.5 23C11.5 23.8284 12.1716 24.5 13 24.5Z"
									fill="#9F2C2C"
								/>
								<path
									d="M20 24.5C20.8284 24.5 21.5 23.8284 21.5 23C21.5 22.1716 20.8284 21.5 20 21.5C19.1716 21.5 18.5 22.1716 18.5 23C18.5 23.8284 19.1716 24.5 20 24.5Z"
									fill="#9F2C2C"
								/>
							</svg>
						</div>
						<p
							v-if="cartContents.length"
							class="user-menu__amount _text-primary"
						>
							{{ cartContents.length }}
						</p>
					</router-link>
					<router-link
						to="/profile/personal-information"
						class="user-menu__link"
					>
						<div
							class="user-menu__icon user-menu__icon_profile _svg-icon"
						>
							<svg
								width="30"
								height="30"
								viewBox="0 0 30 30"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<circle cx="15" cy="15" r="15" fill="white" />
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M11 10C11 8.93913 11.4214 7.92172 12.1716 7.17157C12.9217 6.42143 13.9391 6 15 6C16.0609 6 17.0783 6.42143 17.8284 7.17157C18.5786 7.92172 19 8.93913 19 10C19 11.0609 18.5786 12.0783 17.8284 12.8284C17.0783 13.5786 16.0609 14 15 14C13.9391 14 12.9217 13.5786 12.1716 12.8284C11.4214 12.0783 11 11.0609 11 10ZM11 16C9.67392 16 8.40215 16.5268 7.46447 17.4645C6.52678 18.4021 6 19.6739 6 21C6 21.7956 6.31607 22.5587 6.87868 23.1213C7.44129 23.6839 8.20435 24 9 24H21C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21C24 19.6739 23.4732 18.4021 22.5355 17.4645C21.5979 16.5268 20.3261 16 19 16H11Z"
									fill="#9F2C2C"
								/>
							</svg>
						</div>
					</router-link>
				</div>
			</div>
			<ul v-if="!isAuth" class="header__auth" data-da=".header__nav,439.98">
				<router-link class="header__auth-item _btn-bordered" to="/singup">{{
					$t('Register')
				}}</router-link>
				<router-link class="header__auth-item _btn-primary" to="/signin">{{
					$t('Log in')
				}}</router-link>
			</ul>
			<div
				class="header__icon-menu icon-menu"
				:class="{ 'menu-open': menuVisible }"
				@click="$emit('toggleMenu')"
			>
				<span></span>
			</div>
		</div>
	</header>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
// import CartDropdown from "./CartDropdown.vue";
import { initDynamicAdapt } from '@/utils/dynamic_adapt.js';
import { onClickOutside } from '@vueuse/core';
import { debounce } from 'lodash';

export default {
	name: 'HeaderComponent',
	components: {
		// CartDropdown,
	},
	props: {
		isAuth: { type: Boolean, required: true },
		menuVisible: { type: Boolean, required: true },
		cartContents: { type: Array, required: true },
		isScrolable: { type: Boolean, required: true },
	},
	data() {
		return {
			isScrolled: false,
			showDropdown: false,
			showCartDropdown: false,
			searchTerm: '',
			searchResults: [],
			showSearchResults: false,
			searchIsLoading: false,
			selectedLanguage: null,
			selectedCurrency: null,
			categories: [],
			additionalCategories: [
				//{ name: 'sale', link: '/products/all?sale=true' },
				// { name: 'CONTAINERS', link: '/products/containers' },
				// { name: 'GRAFFITI', link: '/products/graffiti' },
				// { name: 'COLLECTIBLES', link: '/products/collectibles' },
				// { name: 'STICKERS', link: '/products/stickers' },
				// { name: 'PASSES', link: '/products/passes' },
				// { name: 'MUSIC KITS', link: '/products/music-kits' },
				// { name: 'AGENTS', link: '/products/agents' },
				// { name: 'OTHER', link: '/products/other' }
			],
			isHeaderMobile: false,
		};
	},
	computed: {
		...mapState('app', [
			'languages',
			'currencies',
			'currentLanguage',
			'currency',
		]),
		...mapGetters('app', ['currencySymbol']),
		...mapGetters('user', ['userBalance']),
		languageOptions() {
			if (!this.languages) return [];
			return this.languages.map((lang) => ({
				id: lang.id,
				text: lang.title,
			}));
		},
		currencyOptions() {
			return this.currencies.map(({ code }) => ({ id: code, text: code }));
		},
		isDarkHeaderRoute() {
			const path = this.$route.path;
			return path === '/' || path === '/signin' || path === '/singup';
		},
	},
	created() {
		this.debouncedSearchItems = debounce(this.searchItems, 300);
		this.fetchSubcategories();
	},
	watch: {
		currentLanguage(newLang) {
			this.selectedLanguage = newLang;
		},
		searchTerm(newVal) {
			if (!this.$route.query.search || newVal !== this.$route.query.search) {
				this.debouncedSearchItems();
			}
		},
		$route(to) {
			if (
				(to.name === 'ProductListPage' && !to.query.search) ||
				to.name !== 'ProductListPage'
			) {
				this.searchTerm = '';
				this.searchResults = [];
			} else if (to.name === 'ProductListPage' && to.query.search) {
				this.searchTerm = to.query.search;
			}
			this.showSearchResults = false; // Hide results on route change
			this.showDropdown = false;
		},
	},
	mounted() {
		this.selectedLanguage = this.currentLanguage;

		if (this.currency) {
			this.selectedCurrency = this.currency.code;
		}

		if (this.$route.name === 'ProductListPage' && this.$route.query.search) {
			this.searchTerm = this.$route.query.search;
		}
		onClickOutside(this.$refs.dropdownRef, () => {
			this.isOpen = false;
		});

		onClickOutside(this.$refs.searchContainer, () => {
			this.showSearchResults = false;
		});
		window.addEventListener('resize', () => {
			if (window.innerWidth >= 768) {
				this.$emit('closeMenu');
			}
		});
		initDynamicAdapt('max');

		this._onScroll = () => {
			// 1px or more -> add class
			this.isScrolled = window.pageYOffset > 1;
		};
		this._onScroll(); // set initial state
		window.addEventListener('scroll', this._onScroll, { passive: true });

		this.checkMobile();
		this._onResize = () => this.checkMobile();
		this._onOrientation = () => this.checkMobile();

		window.addEventListener('resize', this._onResize, { passive: true });
		window.addEventListener('orientationchange', this._onOrientation);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this._onResize);
		window.removeEventListener('orientationchange', this._onOrientation);
		window.removeEventListener('scroll', this._onScroll);
	},
	methods: {
		sellSkin() {
			if (this.isAuth) {
				//this.$emit('openSellSkinModal');
				this.$router.push('/sell-skin');
			} else {
				this.$router.push('/signin');
			}
		},
		...mapActions('modals', ['openDepositModal']),
		...mapActions('app', ['changeLocale', 'changeCurrency']),
		...mapActions('modals', ['openCartDropdown', 'closeCartDropdown']),
		...mapActions('user', ['fetchUserData']),
		...mapActions('cart', ['fetchCartItems']),
		handleCurrencyChange(e) {
			const value = e?.target ? e.target.value : e;
			this.selectedCurrency = value;
			this.changeCurrency(value);
		},

		handleLanguageChange(e) {
			const value = e?.target ? e.target.value : e;
			this.selectedLanguage = value;
			this.changeLocale(value);
		},
		handleEnterKey() {
			if (this?.searchResults?.length > 0) {
				this.$router.push({
					name: 'ProductListPage',
					params: { itemType: 'all' },
					query: { search: this.searchTerm },
				});
			}
		},
		fetchSubcategories() {
			this.$http
				.get(`items/subcategories`)
				.then((response) => {
					this.categories = response.data.payload;
				})
				.catch((error) => {
					console.error('Error fetching subcategories:', error);
				});
		},
		handleCloseCartDropdown() {
			this.closeCartDropdown();
			if (this.$refs.cartDropdown) {
				this.$refs.cartDropdown.hide();
			}
		},
		searchItems() {
			if (this.searchTerm.length > 2) {
				this.searchIsLoading = true;
				this.$http
					.get(`items/list`, {
						params: { search: this.searchTerm },
					})
					.then((response) => {
						this.searchResults = response.data.payload;
						this.showSearchResults = true;
					})
					.catch((error) => {
						console.error('Error searching items:', error);
						this.searchResults = [];
						this.showSearchResults = false;
					})
					.finally(() => {
						this.searchIsLoading = false;
					});
			} else {
				this.searchResults = [];
				this.showSearchResults = false;
			}
		},
		removeItemFromCart(item) {
			this.$emit('removeOneFromCart', item);
		},
		toggleCartDropdown() {
			this.showCartDropdown = !this.showCartDropdown;
		},
		openSignIn() {
			this.$emit('openSignIn');
		},
		openSignUp() {
			this.$emit('openSignUp');
		},
		hideDropdown() {
			setTimeout(() => {
				if (!this.$el.querySelector('.mega-menu:hover')) {
					this.showDropdown = false;
				}
			}, 100);
		},
		checkMobile() {
			// UA heuristic (covers most mobile browsers)
			const isMobileUA =
				/Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(
					navigator.userAgent
				);
			// Viewport fallback (desktop resized, small windows, etc.)
			const isNarrow = window.matchMedia('(max-width: 767.98px)').matches;

			this.isHeaderMobile = isMobileUA || isNarrow;
		},
	},
};
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as *;
@use '@/assets/styles/media' as *;
@use '@/assets/styles/components/classes' as *;

//========================================================================================================================================================

.header {
	position: fixed;
	left: 0;
	top: 0;
	width: 100%;
	//background-color: var(--bg-fifth-color);
	background-color: transparent;
	border: 1px solid transparent;
	transition: all 0.3s ease 0s;
	z-index: var(--header-z-index);
	&_scrolled {
		background-color: var(--bg-primary-color);
		border-bottom: 1px solid var(--primary-color);
	}
	&_mobile {
		width: 100%;
	}
	&__inner {
		display: flex;
		align-items: center;
		min-height: 64px;
		@media (max-width: $md1) {
			min-height: 50px;
		}
		@include adaptiveValue('gap', 20, 15, 14670, 768, 1);
		@media (max-width: $md4) {
			gap: 15px;
		}
	}
	&__logo {
		@include adaptiveValue('min-width', 277, 117, 1470, 768, 1);
		@include adaptiveValue('min-height', 32, 22, 1470, 768, 1);
		position: relative;
		z-index: var(--header-z-index);
		svg {
			position: absolute;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			path {
				transition: stroke 0.3s ease 0s;
			}
			stop {
				stop-color: var(--hint-primary-color);
				transition: stop-color 0.3s ease 0s;
			}
		}
		@media (any-hover: hover) {
			&:hover {
				svg {
					path {
						stroke: var(--hint-primary-color);
					}
					stop {
						stop-color: var(--hint-primary-color);
					}
				}
			}
		}
		@media (max-width: $md2) {
			margin-right: auto;
		}
	}
	&__nav {
		flex: 1 1 auto;
	}
	&__options {
		display: flex;
		@include adaptiveValue('gap', 20, 10, 14670, 768, 1);
		@media (max-width: $md3) {
			justify-content: center;
			order: 2;
		}
		&-wrapper {
		}
	}
	&__user-menu {
	}
	&__auth {
		display: flex;
		align-self: center;
		gap: 5px;
		@media (max-width: $md5) {
			order: 1;
			width: 100%;
		}
		&-item {
			position: relative;
			z-index: var(--header-z-index);
			@media (max-width: $md1) {
				min-height: 36px;
				padding: 6px 15px;
			}
		}
	}
	&__icon-menu {
		position: relative;
		z-index: var(--header-z-index);
		@media (min-width: $md2) {
			@include hide-item;
		}
	}
}

.nav {
	display: flex;
	justify-content: center;
	@media (max-width: $md2) {
		flex-direction: column;
		justify-content: flex-start;
	}
	@media (max-width: $md2) {
		position: fixed;
		top: 54px;
		left: -100%;
		width: 100%;
		height: 100%;
		z-index: var(--menu-z-index);
		padding: 25px 10px 30px;
		overflow: auto;
		transition: left 0.3s ease 0s;
		background-color: var(--bg-primary-color);
		border-top: 1px solid var(--primary-color);
		&::before {
			content: '';
			position: fixed;
			z-index: var(--header-overlay-z-index);
			top: 0;
			left: -100%;
			width: 100%;
			height: 54px;
			background-color: var(--bg-primary-color);
			transition: left 0.3s ease 0s;
		}
		&.menu-open {
			left: 0;
			&::before {
				left: 0;
			}
		}
	}
	&__list {
		@media (min-width: $md2) {
			display: flex;
		}
		@media (max-width: $md2) {
			order: 2;
		}
	}
	&__item {
		@media (max-width: $md2) {
			margin: 0 -10px;
		}
	}
	&__link {
		cursor: pointer;
		pointer-events: auto;
		&_active {
			pointer-events: none;
			color: var(--hint-color);
			font-weight: 700;
			&::before {
				background-color: var(--primary-color);
			}
		}
	}
}

.user-menu {
	display: flex;
	gap: 20px;
	@media (max-width: $md4) {
		gap: 0px;
	}
	&__wallet {
		position: relative;
		z-index: var(--header-z-index);
	}
	&__actions {
		display: flex;
	}
	&__link {
		position: relative;
		z-index: var(--header-z-index);
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: transparent;
		min-height: 60px;
		@include adaptiveValue('padding-left', 20, 10, 1470, 768, 1);
		@include adaptiveValue('padding-right', 20, 10, 1470, 768, 1);
		transition: border 0.3s ease 0s;
		border-bottom: 2px solid transparent;
		pointer-events: auto;
		&.router-link-active {
			border-bottom: 2px solid var(--primary-color);
			pointer-events: none;
		}
		@media (any-hover: hover) {
			&:hover {
				.user-menu__icon_cart {
					svg {
						circle {
							fill: transparent;
						}
					}
				}
				.user-menu__icon_profile {
					svg {
						circle {
							fill: transparent;
						}
					}
				}
			}
		}
		@media (max-width: $md1) {
			min-height: 54px;
		}
	}
	&__icon {
		min-width: 24px;
		height: 24px;
		&_cart {
			circle {
				fill: var(--primary-color);
				transition: fill 0.3s ease 0s;
			}
		}
		&_profile {
			circle {
				fill: var(--primary-color);
				transition: fill 0.3s ease 0s;
			}
		}
	}
	&__amount {
		transform: translateY(-50%);
		color: var(--primary-color);
		max-width: 28px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
}

.wallet {
	display: flex;
	align-items: center;
	gap: 5px;
	cursor: pointer;
	@media (max-width: $md4) {
		padding-right: 5px;
	}
	@media (max-width: $md4) {
		padding: 0px 10px;
	}
	@media (any-hover: hover) {
		&:hover {
			.wallet__more {
				color: var(--hint-color);
			}
		}
	}
	&__icon {
		min-width: 20px;
		height: 20px;
	}
	&__amount {
		font-size: 20px;
		font-weight: 900;
		font-family: var(--font-family-geologica);
		max-width: 80px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}
	&__more {
		font-size: 22px;
		font-weight: normal;
		font-family: var(--font-family-geologica);
		transition: color 0.3s ease 0s;
	}
}

// burger icon
.icon-menu {
	display: none;
	@media (max-width: $md2) {
		display: block;
		position: relative;
		width: 30px;
		height: 18px;
		cursor: pointer;
		z-index: 12;
		span,
		&::before,
		&::after {
			content: '';
			transition: all 0.3s ease 0s;
			right: 0;
			position: absolute;
			width: 100%;
			height: 2px;
			background-color: var(--primary-color);
		}
		&::before {
			top: 0;
		}
		&::after {
			bottom: 0;
		}
		span {
			top: calc(50% - 1px);
		}
		&.menu-open {
			span {
				width: 0;
			}
			&::before,
			&::after {
			}
			&::before {
				top: calc(50% - 1px);
				transform: rotate(-45deg);
			}
			&::after {
				bottom: calc(50% - 1px);
				transform: rotate(45deg);
			}
		}
	}
}
</style>
